import React from 'react';
import { CheckCircle2, Star, Shield, Users } from 'lucide-react'; 
import './Leadership.css';

const Leadership = () => {
  return (
    <section className="leadership-section" id="leadership">
      <div className="container">
        <div className="leadership-grid">
          
          {/* --- LEFT COLUMN: Brand Ethos (Clean & Pleasant) --- */}
          <div className="leadership-content">
            <span className="subtitle-badge">Why Choose Us</span>
            <h2 className="section-title">
              Service Beyond <span className="highlight">Sale.</span>
            </h2>
            
            <p className="description-text">
              "We're not here to sell — we're here to serve." With decades of combined experience in real estate, financial services, and legal advisory, we ensure a smooth, stress-free, and trustworthy realty journey.
            </p>

 <div className="ethos-grid">
              {/* Card 1: Client-Centricity */}
              <div className="ethos-card">
                <div className="card-icon-wrapper">
                  <Users size={24} strokeWidth={1.5} />
                </div>
                <div className="card-content">
                  <h4>Client-Centricity</h4>
                <p>Prioritizing client needs and delivering solutions that exceed expectations.</p>
                </div>
                <div className="hover-line"></div>
              </div>
              
              {/* Card 2: Integrity */}
              <div className="ethos-card">
                <div className="card-icon-wrapper">
                  <Shield size={24} strokeWidth={1.5} />
                </div>
                <div className="card-content">
                  <h4>Integrity</h4>
             <p>Transparency and honesty guide every interaction].</p>
                </div>
                <div className="hover-line"></div>
              </div>

              {/* Card 3: Professional Excellence */}
              <div className="ethos-card">
                <div className="card-icon-wrapper">
                  <Star size={24} strokeWidth={1.5} />
                </div>
                <div className="card-content">
                  <h4>Excellence</h4>
             <p>Expert advice, insights, and flawless execution.</p>
                </div>
                <div className="hover-line"></div>
              </div>

              {/* Card 4: Accountability */}
              <div className="ethos-card">
                <div className="card-icon-wrapper">
                  <CheckCircle2 size={24} strokeWidth={1.5} />
                </div>
                <div className="card-content">
                  <h4>Accountability</h4>
             <p>We take responsibility for every commitment made.</p>
                </div>
                <div className="hover-line"></div>
              </div>
            </div>
          </div>

          {/* --- RIGHT COLUMN: Premium Team Card (The "Luxury" Element) --- */}
          <div className="team-wrapper">
            <div className="team-card">
              {/* Decorative Header inside card */}
              <div className="team-header">
                <h3>Executive Leadership</h3>
                <div className="gold-line"></div>
              </div>
              
              <div className="leaders-list">
                {/* Leader 1 */}
                <div className="leader-row">
                  <div className="leader-avatar">PP</div>
                  <div className="leader-details">
                    <h4>Mr. Pradeep Patel</h4>
                    <span className="role">Managing Partner</span>
                    <p className="bio">Ex-Bajaj Capital, SBILIFE, PNB METLIFE.</p>
                  </div>
                </div>

                {/* Leader 2 */}
                <div className="leader-row">
                  <div className="leader-avatar">MR</div>
                  <div className="leader-details">
                    <h4>Mr. Muddam Ravinder Reddy</h4>
                    <span className="role">Managing Partner</span>
                    <p className="bio">Ex-ING Vysya & SBI Life Insurance.</p>
                  </div>
                </div>

                {/* Leader 3 */}
                <div className="leader-row">
                  <div className="leader-avatar">SP</div>
                  <div className="leader-details">
                    <h4>Ms. Shailaja Patel</h4>
                    <span className="role">Independent Director</span>
                    <p className="bio">Practicing Advocate, Legal & Project Advisory.</p>
                  </div>
                </div>
              </div>

              {/* Watermark Logo Effect */}
              <div className="card-watermark">PG</div>
            </div>
            
            {/* Background shadow decoration */}
            <div className="team-shadow-box"></div>
          </div>

        </div>
      </div>
    </section>
  );
};

export default Leadership;